var redis = "redis"


// http://guid.us/GUID/JavaScript  

function createGuid() {
	function S4() {
		return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
	}
	return (S4() + S4() + "-" + S4() + "-4" + S4().substr(0, 3) + "-" + S4() + "-" + S4() + S4() + S4()).toLowerCase();
}




/**
 * 设置
 * k 键key
 * v 值value
 * t 秒
 */
function putRedis(k, v, t) {
    v=JSON.stringify(v)
	window.localStorage.setItem(k, v)
	var seconds = parseInt(t)
	if (seconds > 0) {
		var newtime = Date.parse(new Date())
		newtime = newtime / 1000 + seconds;
		window.localStorage.setItem(k + redis, newtime + "")
	} else {
		window.localStorage.removeItem(k + redis)
	}
}
/**
 * 获取
 * k 键key
 */
function getRedis(k) {
	var deadtime = parseInt(window.localStorage.getItem(k + redis))
	if (deadtime) {
		if (parseInt(deadtime) < Date.parse(new Date()) / 1000) {
			window.localStorage.removeItem(k);
			console.log("过期了")
			return null
		}
	}
	var res = window.localStorage.getItem(k)
	if (res) {
		return JSON.parse(res)
	} else {
		return null
	}
}

/**
 * 删除
 */
function removeRedis(k) {
	window.localStorage.removeItem(k);
	window.localStorage.removeItem(k + redis);
}

/**
 * 清除所有key
 */
function clearRedis() {
	window.localStorage.clear();
}




module.exports = {
	putRedis,
	getRedis,
	removeRedis,
	clearRedis,
	createGuid
}
